<template>
    <b-card no-body>
        <b-tabs pills card vertical>
            <b-tab title="Termos de uso" class="editor__parent" active>
                <vue-editor v-model="termos" class="editor__body"/>
                <b-card-footer class="d-flex">
                    <b-button variant="success" v-if="permissao.u" @click="salvarTermos">
                        <i class="fa-solid fa-check mr-2"></i>
                        Salvar
                    </b-button>
                </b-card-footer>
            </b-tab>
            <b-tab title="Politicas de privacidade" class="editor__parent">
                <vue-editor v-model="politica" class="editor__body"/>
                <b-card-footer class="d-flex">
                    <b-button variant="success" v-if="permissao.u"  @click="salvarPolitica">
                        <i class="fa-solid fa-check mr-2"></i>
                        Salvar
                    </b-button>
                </b-card-footer>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>

import { VueEditor } from "vue2-editor";
import TermosService from "@/common/services/termos/termos.service";
import Swal from "sweetalert2";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

export default {
    components: {
        VueEditor
    },
    data : () =>({
        termos : null,
        politica : null
    }),
    mounted () {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            { titulo: this.$t("MENU.TERMOS") }
        ]);
        
        this.getTermos();
        this.getPolitica();
    },
    computed : {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('TermosPolitica');
        },
    },
    methods :{
        getTermos : function(){
            TermosService.getTermos().then(response => {
                this.termos = response.data.data;
            });
        },
        salvarTermos : function(){
            Swal.fire({
                title: "Aviso",
                text: "Alterar termos de uso?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: 'Sim',
                denyButtonText: `Não`
            }).then((result) =>{
                if (result.isConfirmed) {
                    this.$store.dispatch(START_LOADING);
                    let form = {
                        termosServico: this.termos,
                    }
                    TermosService.salvarTermo(form).then(() => {
                        Swal.fire({
                            title: "Sucesso",
                            text: "Termos de uso atualizados com sucesso!",
                            icon: "success"
                        });
                    }).catch(() => {
                        Swal.fire({
                            title: "Erro",
                            text: "Erro ao atualizar termos de uso!",
                            icon: "error"
                        });
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            });
        },
        
        getPolitica : function(){
            TermosService.getPolitica().then(response => {
                this.politica = response.data.data;
            });
        },
        salvarPolitica : function(){
            Swal.fire({
                title: "Aviso",
                text: "Alterar politica de privacidade?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: 'Sim',
                denyButtonText: `Não`
            }).then((result) =>{
                if (result.isConfirmed) {
                    this.$store.dispatch(START_LOADING);
                    let form = {
                        politicaPrivacidade: this.politica,
                    }
                    TermosService.salvarPolitica(form).then(() => {
                        Swal.fire({
                            title: "Sucesso",
                            text: "Politica de privacidade atualizada com sucesso!",
                            icon: "success"
                        });
                    }).catch(() => {
                        Swal.fire({
                            title: "Erro",
                            text: "Erro ao atualizar politica de privacidade!",
                            icon: "error"
                        });
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            });
        },
    }
}
</script>
<style>
    .tabs {
        border: 1px solid #ccc;
        border-radius: 3px;
    }

    .card-footer {
        border-left: 1px solid #ccc;
    }

    .editor__parent{
        padding: 0 !important;
    }

    .ql-toolbar {
        border-top: none !important;
        border-right: none !important;
    }

    .ql-container{
        border-top: none !important;
        border-right: none !important;
        
    }

    .ql-editor{
        height: 300px !important;
    }

    /* Configurações globais */
    .nav-pills .nav-link.active, .nav-pills .show > .nav-link{
        background-color: #EDBB64 !important;
    }

</style>